import React from "react";
import { Authenticator } from "aws-amplify-react";

import App from "../../App";
import withRoot from "../../withRoot"
import authErrorMap from "../../libs/authErrorMap";
import CustomSignIn from "./CustomSignIn";
import CustomForgotPassword from "./CustomForgotPassword";
import CustomRequireNewPassword from "./CustomRequireNewPassword";

import config from "../../config.json";


function AppWithAuth() {
  return (
    <Authenticator hideDefault={true} authState="signIn" amplifyConfig={config.Amplify} errorMessage={authErrorMap}>
      <CustomSignIn override={'SignIn'}/>
      <CustomForgotPassword override={'ForgotPassword'}/>
      <CustomRequireNewPassword override={'RequireNewPassword'}/>
      <App />
    </Authenticator>
  );
}

export default withRoot(AppWithAuth);
